<script>
import { formatTenThousand } from 'common/js/format'
export default {
  name: 'SummaryPbTable',
  components: {},
  filters: {
    displayBaoe(item) {
      let baoeDp = formatTenThousand(item.baoeDesc || item.baoe) || '-'
      if (!item.calMethod) {
        if (item.showPlanDesc) {
          baoeDp = item.planDesc
        } else if (item.showPlanDesc === 'undefined') {
          // planDesc 存在且不等于 plan 显示
          if (item.planDesc && item.planDesc != item.plan) {
            baoeDp = item.planDesc
          }
        }
      }
      return baoeDp
    },
    displayEmpty(value) {
      return value || value === 0 ? value : '-'
    },
    displayInteger(value) {
      return Math.floor(value)
    },
    displaySex(value) {
      return value === 2 ? '女' : '男'
    },
  },
  mixins: [],
  props: {
    // init: {
    //   type: Boolean,
    //   default: false
    // },
    pbResultData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {}
  },
  computed: {
    insuredInfo() {
      const { pbResultData } = this
      if (
        !pbResultData ||
        !pbResultData.resultData ||
        !pbResultData.resultData.personData ||
        !Array.isArray(pbResultData.resultData.personData.personOrderList)
      )
        return {}
      const person = pbResultData.resultData.personData.personOrderList.filter(
        (item) => {
          return item.key === 'insuredInfo'
        }
      )[0]
      return person && person.title ? person : ''
    },
    applicantInfo() {
      const { pbResultData } = this
      if (
        !pbResultData ||
        !pbResultData.resultData ||
        !pbResultData.resultData.personData ||
        !Array.isArray(pbResultData.resultData.personData.personOrderList)
      )
        return {}
      const person = pbResultData.resultData.personData.personOrderList.filter(
        (item) => {
          return item.key === 'applicantInfo'
        }
      )[0]
      return person && person.title ? person : ''
    },
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    getTotalbaofei(list) {
      const member = list
      if (!member || !member.insurances) return '-'
      const security = member.insurances
      let total = 0
      security.forEach((ins) => {
        if (!ins.insuranceData) return
        ins.insuranceData.forEach((item) => {
          let baof = item[2]
          baof = typeof baof === 'number' ? baof : 0
          total += baof
        })
      })
      return total.toFixed(2)
    },
  },
}
</script>

<template>
  <div class="summary-table">
    <table class="overview-pb-table">
      <thead>
        <tr>
          <th>被保人</th>
          <th v-if="applicantInfo">
            投保人
          </th>
          <th>公司</th>
          <th>保障计划</th>
          <th>险种名称</th>
          <th>保障期间</th>
          <th>交费期间</th>
          <th>保险金额(元)</th>
          <th>年交保费(元)</th>
        </tr>
      </thead>
      <tbody>
        <!-- <tr>
          <td colspan="8">
            <span class="head-name">被保人</span><img class="head-image"
              :src="tb.relationImg"
              :alt="tb.clientRelation"><span class="mb-name">{{tb.name}}</span></td>
          <td>{{getTotalbaofei(resultData[tb.cid].lib)}}</td>
        </tr> -->
        <tr v-for="(item, index) in pbResultData.tableData">
          <td
            v-if="insuredInfo && index === 0"
            :rowspan="pbResultData.tableData.length"
          >
            {{ insuredInfo.sex | displaySex }} {{ insuredInfo.age }}岁
          </td>
          <td
            v-if="applicantInfo && index === 0"
            :rowspan="pbResultData.tableData.length"
          >
            {{ applicantInfo.sex | displaySex }} {{ applicantInfo.age }}岁
          </td>
          <td>{{ item.pdCompanyName }}</td>
          <td>{{ item.pdTitleName }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.iDurationDesc | displayEmpty }}</td>
          <td>{{ item.pPeriodDesc | displayEmpty }}</td>
          <td>{{ item | displayBaoe }}</td>
          <td>{{ item.baofDesc || item.baof | displayEmpty }}</td>
        </tr>
        <!-- <tr v-if="ti === members.length - 1">
          <td colspan="10">温馨提示：以上演示说明为本平台对上述产品的理解，便于保险从业人员学习、交流，演示数据仅供参考，请以实际为准。</td>
        </tr> -->
      </tbody>
    </table>
  </div>
</template>

<style>
@import 'variable';

.overview-pb-table {
  margin-bottom: 32px;
  th:nth-child(1),
  th:nth-child(2) {
    width: 7%;
  }
  th:nth-child(3) {
    width: 12%;
  }
  th:nth-child(4),
  th:nth-child(5) {
    width: 16%;
  }
  tbody {
    tr:first-child {
      td {
        background-color: #fdfdfd;
      }
    }
  }
  .head-name {
    margin-left: 10px;
    margin-right: 40px;
  }
  .head-image {
    display: inline-block;
    width: 36px;
    height: 36px;
    margin-right: 6px;
    vertical-align: middle;
  }
  .mb-name {
    display: inline-block;
    vertical-align: middle;
  }
}
</style>